<script lang="ts" setup>
  import { computed, onMounted, onUnmounted } from 'vue'
  import LandingFooter from '@/components/landingPage/LandingFooter.vue'
import { useTypedRoute } from '@/composables'
  import { useAxios } from '@/composables/useAxios'
  import { useLocale } from '@/composables/useLocale'
  import { useJwtStore, useVersionStore } from '@/stores'

  defineOptions({ name: 'LandingLayout' })

  const route = useTypedRoute<Record<string, string | string[]>>()
  const jwtStore = useJwtStore()
  const versionStore = useVersionStore()
  const { initLocaleFromAccount } = useLocale()

  const footerMarginClass = computed<string>(() => (route.name === 'landingPage' ? '' : 'mt-16'))

  onMounted(async () => {
    // Only when the URL does not already state a locale. On /de/... or /en/...
    // the path IS the contract: letting the account or browser language win
    // here flips the page one frame after hydration, rewrites <html lang> and
    // makes every link and the canonical disagree with the address bar.
    if (!route.params.locale) {
      if (jwtStore.getJwt) {
        try {
          const res = await useAxios<null, { lang?: string }>('GET', '/account', true)
          initLocaleFromAccount(res?.data?.lang)
        } catch {
          initLocaleFromAccount()
        }
      } else {
        initLocaleFromAccount()
      }
    }

    versionStore.startVersionWatcher()
  })

  onUnmounted(() => {
    versionStore.stopVersionWatcher()
  })

</script>

<template>
  <div class="landing-layout">
    <v-sheet id="content" class="layout-content" color="transparent">
      <slot />
    </v-sheet>

    <landing-footer :class="['layout-footer', footerMarginClass]" />
  </div>
</template>

<style scoped>
  .landing-layout {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  .layout-content {
    flex: 1 1 auto;
    overflow: visible;
  }
  .layout-footer {
    margin-top: auto;
  }
</style>
